<template>
  <div class>
    <div class="row">
      <div class="col-md-13 col-sm-13">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-5">
                <form-text label="Search Assets" name="searchassets" v-model="searchQuery"></form-text>
              </div>
              <div
                class="col-md-2"
                v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == '2' || org['curOrg']['role'] == 99"
              >
                <router-link to class="btn btn-success">Add</router-link>
              </div>
            </div>
            <br>
            <assets-table :data="assets" :columns="gridColumns" :filter-key="searchQuery"></assets-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetsTable from "./AssetsTable";
import FormText from "../../elements/Form/FormText";
import database from "../../webmaster/Database/database";
import store from "../../webmaster/Store/vuex";

export default {
  name: "inventory",
  components: {
    "assets-table": AssetsTable,
    "form-text": FormText
  },
  data() {
    return {
      org: store.state.usermain,
      assets: {
        "hi" : {
          name: "Mattress",
          groups: "Bedding",
          total: 5027,
          allocated: 4924,
          instock: 103,
          location: "C-12"
        },
        "889526094584" : {
          ".key": "889526094584",
          name: "3/32-Inch Drill Bits",
          groups: "Tools",
          total: 47,
          allocated: 8,
          instock: 39,
          location: "B-15"
        },
        "hi2" : {
          name: "Hammer",
          groups: "Tools",
          total: 84,
          allocated: 37,
          instock: 47,
          location: "A-11"
        },
        "hi3" : {
          name: "T-Shirt",
          groups: "Clothing",
          total: 5048,
          allocated: 4924,
          instock: 124,
          location: "D-28"
        },
        "hi4" : {
          name: "Pants",
          groups: "Clothing",
          total: 5048,
          allocated: 4924,
          instock: 124,
          location: "D-29"
        },
        "hi5" : {
          name: "Towel",
          groups: "Hygiene",
          total: 5134,
          allocated: 4370,
          instock: 764,
          location: "B-04"
        }
      },
      searchQuery: "",
      gridColumns: [
        "name",
        "groups",
        "total",
        "allocated",
        "allocated %",
        "in stock",
        "in stock %",
        "location",
        "more"
      ],
      gridColumns_export: {
        name: "String",
        groups: "String",
        total: "String",
        allocated: "String",
        "allocated %": "String",
        "in stock": "String",
        "in stock %": "String",
        location: "String",
        more: "String"
      }
    };
  },
  created:function() {
    //this.fetchAssets();
  },
  methods: {
    fetchAssets: function(){
      let orgId = this.$store.state.usermain.curOrg.id;

      let self = this;

      let collection = database.getFireStoreColl('orgs/' + orgId + '/assets/');

      collection.get().then(function(querySnapshot) {
        let _assets = {}

        querySnapshot.forEach(doc => {
          console.log(doc.data())
          
          _assets.add(doc.data())
        });

        self.assets = _assets;
      });

      console.log("Imma done");

    },
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// Assets.vue?2c44cb88